module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('article', {
    staticClass: "container"
  }, [_c('div', {
    class: _vm.loadingClass
  }, [_vm._v("\n    " + _vm._s(_vm.LoadingText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "i18n-buttons"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    class: _vm.i18nButtonStyle('en'),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.i18nClickHandler('en')
      }
    }
  }, [_vm._v("en")]), _vm._v(" "), _c('button', {
    class: _vm.i18nButtonStyle('zh'),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.i18nClickHandler('zh')
      }
    }
  }, [_vm._v("zh")])])]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', [_c('markdown', {
      attrs: {
        "source": item
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7339a096"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/app.vue
// module id = 161
// module chunks = 0